module.exports = __webpack_public_path__ + "static/img/home_dibu_icon_@2x.4bf02d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/home_dibu_icon_@2x.png
// module id = 8yDD
// module chunks = 0